const questions = [
  "Have you been feeling perfectly well and in good health?",
  "Have you recently been feeling in need of a good medicine?",
  "Have you been feeling run down and low in energy?",
  "Have you felt that you are ill",
  "Have you recently been feeling full of energy?",
  "Have you been getting any pains in your head?",
  "Have you been getting a feeling of tightness or pressure in your head?",
  "Have you recently been afraid that you were going to collapse in a public place?",
  "Have you been having hot or cold spells?",
  "Have you been perspiring (sweating) a lot?",
  "Have you found yourself waking up early and unable to get back to sleep?",
  "Have you recently been getting up, feeling your sleep hasn't refreshed you?",
  "Have you recently had difficulty in getting off to sleep?",
  "Have you had difficulty in staying asleep?",
  "Have you been having restless, disturbed nights?",
  "Have you been managing to keep yourself busy and occupied?",
  "Have you recently felt on the whole that you were doing things well?",
  "Have you recently felt satisfied with the way you've carried out your task?",
  "Have you recently felt capable of making decisions about things?",
  "Have you recently been able to enjoy your normal day-to-day activities?",
  "Have you recently been getting scared or panicky for no good reason?",
  "Have you been finding everything getting on top of you?",
  "Have you been feeling unhappy and depressed?",
  "Have you recently been losing confidence in yourself?",
  "Have you recently been feeling nervous and strung-up all the time?",
  "Have you recently felt that life is entirely hopeless",
  "Have you recently felt that life isn't worth living?",
  "Have you recently thought of the possibility that you might make away with yourself?",
  "Have you recently found yourself wishing that you were dead and away from it all?",
  "Have you recently found that the idea of taking your own life keeps coming to your mind?",
];

const optionArray = [
  [
    "Better than usual",
    "Same as usual",
    "Worse than usual",
    "Much worse than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Better than usual",
    "Same as usual",
    "Worse than usual",
    "Much worse than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "More so than usual",
    "Same as usual",
    "Less than usual",
    "Much less than usual",
  ],
  [
    "Better than usual",
    "Same as usual",
    "Worse than usual",
    "Much worse than usual",
  ],
  ["More satisfied", "About the same", "Less satisfied", "Much less satisfied"],
  [
    "More so than usual",
    "Same as usual",
    "Less than usual",
    "Much less than usual",
  ],
  [
    "More so than usual",
    "Same as usual",
    "Less than usual",
    "Much less than usual",
  ],
  [
    "More so than usual",
    "Same as usual",
    "Less than usual",
    "Much less than usual",
  ],
  [
    "More so than usual",
    "Same as usual",
    "Less than usual",
    "Much less than usual",
  ],
  [
    "More so than usual",
    "Same as usual",
    "Less than usual",
    "Much less than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Definitely not",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Not at all",
    "No more than usual",
    "Rather more than usual",
    "Much more than usual",
  ],
  [
    "Definitely not",
    "I don't think so",
    "Has crossed my mind",
    "Definitely has",
  ],
];

export { questions, optionArray };
